import './App.css';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import Footer from './Components/Footer';
import Home from './Components/Home';
import Contact from './Components/Contact';
import Services from './Components/Services';
import About from './Components/About';

function App() {
  return (
    <BrowserRouter>
    <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        <Footer/>
      </div>
    </BrowserRouter>
  );
}

export default App;
